// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPaymentAddressRequestDto
 */
export interface IPaymentAddressRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentAddressRequestDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    line4?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    state: string;
    /**
     * 
     * @type {number}
     * @memberof IPaymentAddressRequestDto
     */
    country_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentAddressRequestDto
     */
    zipcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentAddressRequestDto
     */
    validated?: boolean;
}

/**
 * Check if a given object implements the IPaymentAddressRequestDto interface.
 */
export function instanceOfIPaymentAddressRequestDto(value: object): value is IPaymentAddressRequestDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('country_id' in value) || value['country_id'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    return true;
}

export function IPaymentAddressRequestDtoFromJSON(json: any): IPaymentAddressRequestDto {
    return IPaymentAddressRequestDtoFromJSONTyped(json, false);
}

export function IPaymentAddressRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentAddressRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'],
        'state': json['state'],
        'country_id': json['country_id'],
        'zipcode': json['zipcode'],
        'validated': json['validated'] == null ? undefined : json['validated'],
    };
}

export function IPaymentAddressRequestDtoToJSON(json: any): IPaymentAddressRequestDto {
    return IPaymentAddressRequestDtoToJSONTyped(json, false);
}

export function IPaymentAddressRequestDtoToJSONTyped(value?: IPaymentAddressRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': value['state'],
        'country_id': value['country_id'],
        'zipcode': value['zipcode'],
        'validated': value['validated'],
    };
}

